var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1411,
    height: 1411,
    viewBox: "0 0 1411 1411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M705.5 1411C315.532 1411 0 1095 0 705.5C0 315.532 316 0 705.5 0C1095.47 0 1411 316 1411 705.5C1411.47 1095.47 1095.47 1411 705.5 1411Z",
    fill: "#9BD6A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_249_824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1412,
    height: 1411
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M705.5 1411C315.532 1411 0 1095 0 705.5C0 315.532 316 0 705.5 0C1095.47 0 1411 316 1411 705.5C1411.47 1095.47 1095.47 1411 705.5 1411Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_249_824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100.58 1299.57C1097.29 1301.92 1093.52 1304.27 1090.23 1306.62C1086.47 1308.97 1083.18 1311.32 1079.41 1313.2C1076.12 1315.09 1073.3 1316.97 1070.01 1318.85C1069.54 1319.32 1069.07 1319.32 1068.6 1319.79C1057.78 1326.37 1046.49 1332.49 1035.2 1338.13C1031.91 1340.01 1028.15 1341.9 1024.86 1343.31C1024.86 1343.31 1024.39 1343.78 1023.92 1343.78C1020.15 1345.66 1016.39 1347.54 1012.63 1349.42C1005.1 1353.18 997.107 1356.48 989.581 1359.77C985.819 1361.65 981.586 1363.06 977.823 1364.47C974.06 1365.88 969.827 1367.76 966.065 1369.17C962.302 1370.59 958.069 1372.47 954.306 1373.88C954.306 1373.88 954.306 1373.88 953.836 1373.88C950.073 1375.29 945.84 1376.7 942.078 1378.11C933.612 1380.93 924.675 1383.75 916.209 1386.58C913.387 1387.52 910.095 1388.46 907.273 1389.4C898.337 1392.22 889.4 1394.57 880.464 1396.45C877.172 1397.39 873.879 1397.86 870.117 1398.81C861.651 1400.69 852.714 1402.57 844.248 1404.45C842.367 1404.92 840.956 1404.92 839.075 1405.39C836.253 1405.86 832.96 1406.33 830.138 1406.8C825.905 1407.27 822.143 1408.21 817.91 1408.68C816.028 1409.15 814.147 1409.15 812.266 1409.62C809.914 1410.09 807.092 1410.56 804.27 1410.56C796.745 1411.5 788.749 1412.45 781.224 1413.39C778.872 1413.86 776.05 1413.86 773.698 1414.33H773.228C769.936 1414.8 766.643 1414.8 763.351 1415.27C760.059 1415.74 756.766 1415.74 753.474 1415.74C751.593 1415.74 749.241 1416.21 747.36 1416.21C743.597 1416.21 740.305 1416.68 737.013 1416.68C732.309 1416.68 728.076 1417.15 723.373 1417.15C718.669 1417.15 714.437 1417.15 709.733 1417.15C706.441 1417.15 703.149 1417.15 699.856 1417.15C501.846 1414.33 323.119 1330.14 196.129 1196.56C196.129 1196.56 196.129 1196.09 195.659 1196.09C210.239 1167.4 264.328 1115.66 320.768 1072.86C392.258 1018.78 493.38 985.383 493.38 985.383C493.38 985.383 559.697 974.565 805.681 1025.83C993.344 1065.34 1073.3 1225.72 1100.58 1299.57Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.888 1156.11C848.011 1204.56 784.046 1233.25 676.339 1189.98C544.176 1136.36 493.38 985.382 493.38 985.382C486.325 877.206 469.863 784.55 469.863 784.55C622.722 771.381 803.329 950.107 803.329 950.107L824.024 1038.53C825.905 1046.06 829.668 1052.64 835.312 1057.34C845.189 1074.28 864.473 1125.07 857.888 1156.11Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.312 1057.81C745.479 1053.11 679.162 1039.94 608.141 912.481C668.344 965.629 739.364 985.853 814.147 995.26L824.024 1038.53C825.906 1046.53 829.668 1053.11 835.312 1057.81Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.09 491.062C1029.56 530.57 1033.79 562.553 1010.75 667.907C987.7 773.262 1031.91 878.617 920.913 975.035C846.13 1039.94 715.377 1052.17 610.963 981.149C575.688 957.162 543.235 923.769 516.897 880.028C496.202 845.693 472.215 813.24 445.406 783.609C408.25 743.161 363.568 661.793 385.674 517.871C421.419 283.645 653.293 256.836 790.16 282.704C927.027 308.573 998.047 386.648 1021.09 491.062Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.985 674.962C570.985 674.962 556.405 604.412 487.736 612.878C428.474 620.404 407.779 762.444 542.295 801.952",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.062 737.517C538.062 737.517 521.13 726.699 523.011 707.886C525.833 685.78 523.011 672.14 512.664 667.907C486.795 657.09 481.622 687.191 482.562 690.954",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.926 783.139C896.926 783.139 914.799 784.08 931.73 763.855C941.137 752.567 949.133 738.457 943.959 734.224C938.786 729.521 853.655 742.69 848.011 753.978C842.367 765.266 875.291 783.139 896.926 783.139Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.036 625.107C911.036 625.107 911.976 669.789 940.667 719.644C953.366 741.75 934.082 777.965 892.222 784.08",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M656.115 807.126C682.87 807.126 704.56 789.227 704.56 767.148C704.56 745.068 682.87 727.17 656.115 727.17C629.36 727.17 607.671 745.068 607.671 767.148C607.671 789.227 629.36 807.126 656.115 807.126Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1003.22 728.11C1001.81 754.449 1002.28 780.317 1000.4 806.185C979.704 801.482 964.654 785.961 964.654 767.618C964.654 747.864 981.115 731.873 1003.22 728.11Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.1 1211.95C1081.31 1125.88 977.841 1090.13 920.931 1068.97C916.228 1045.45 907.291 1019.58 893.181 994.653C871.546 1007.82 846.618 1017.7 820.75 1022.87L824.513 1038.39C826.394 1045.92 835.801 1080.72 821.22 1125.41C808.992 1163.03 759.607 1179.96 675.887 1141.87C512.682 1068.03 493.868 984.776 493.868 984.776C491.047 939.624 486.343 897.294 482.11 862.96C431.314 874.248 372.523 897.294 340.54 945.738C301.032 1005 286.452 1065.2 290.214 1113.18C221.546 1156.92 115.25 1223.24 80.4456 1341.76C35.2936 1496.03 42.8189 1590.57 42.8189 1590.57H1258.16C1256.75 1591.04 1238.88 1329.06 1148.1 1211.95Z",
    fill: "#6060D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.436 1057.68C421.436 1057.68 450.127 1169.15 575.706 1246.28",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.461 1068.97C920.461 1068.97 953.855 1213.36 880.953 1279.68",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.76 1257.57C693.76 1257.57 669.303 1329.06 675.887 1378.45",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.797 1253.34C843.797 1253.34 862.14 1293.31 875.309 1356.81",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.274 1113.65C289.274 1113.65 327.841 1270.74 557.363 1316.83",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.12 1389.26L659.426 1387.38C651.9 1386.44 646.256 1379.39 647.667 1371.86L654.722 1336.59C656.604 1326.71 666.01 1319.65 675.887 1321.06C685.764 1322.01 693.76 1330.47 693.76 1340.82L694.23 1377.03C694.23 1384.09 687.646 1390.2 680.12 1389.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.004 1367.63L876.25 1374.68C868.724 1377.5 860.729 1372.8 859.318 1365.28L850.852 1330.47C848.5 1320.59 853.674 1310.72 863.551 1306.95C872.958 1303.66 883.775 1307.89 888.008 1316.83L903.529 1349.28C906.822 1356.34 903.529 1364.81 896.004 1367.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.42 1356.81C1103.42 1356.81 1129.76 1504.49 1119.41 1591.04",
    stroke: "#544D4D",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.341 672.33C731.053 671.86 722.587 662.453 723.528 651.165L723.998 637.996C724.468 626.708 733.875 618.242 745.163 619.182C756.451 619.653 764.917 629.059 763.976 640.347L763.506 653.517C763.036 664.334 753.629 672.8 742.341 672.33Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.351 679.385C930.004 678.914 922.008 669.978 922.478 659.631L922.949 647.402C923.419 637.055 932.355 629.059 942.703 629.529C953.05 630 961.046 638.936 960.575 649.283L960.105 661.512C959.635 671.859 950.698 679.855 940.351 679.385Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.964 645.051C787.964 645.051 775.735 627.648 754.57 624.356C737.168 621.534 717.884 630 715.062 639.877",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.712 649.284C926.712 649.284 926.712 634.233 948.347 634.233C966.22 634.233 973.745 650.695 973.745 650.695",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.246 569.326C817.123 572.619 827 563.682 825.119 552.865C824.178 547.221 821.827 541.577 817.123 537.344C803.013 524.645 744.692 513.357 709.417 529.818C678.375 544.869 762.094 554.276 807.246 569.326Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.875 576.852C939.879 579.674 931.413 571.208 932.824 561.331C933.295 556.157 935.176 550.984 938.939 547.221C950.227 535.933 988.794 526.997 1013.25 544.399C1034.42 558.979 984.561 563.212 947.875 576.852Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.862 836.436C863.311 843.625 857.919 856.205 848.035 865.19C797.266 834.19 774.352 850.364 774.352 850.364C756.381 822.958 760.424 785.667 804.005 813.972C834.557 833.291 852.977 836.436 862.862 836.436Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.036 865.191C837.253 874.626 821.078 880.466 799.063 871.481C788.73 867.437 780.643 859.35 774.353 850.364C774.353 850.364 797.266 834.19 848.036 865.191Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.399 834.639C871.399 834.639 852.529 844.973 804.006 813.972C746.048 776.681 757.729 854.857 798.614 871.481C841.296 889.003 863.311 850.814 862.862 836.437",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.353 850.364C774.353 850.364 797.266 834.19 848.036 865.191",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.39 377.526C1023.99 498.402 927.105 478.177 836.331 445.254C715.455 401.043 609.16 436.788 608.69 545.905C607.749 705.819 567.771 657.374 563.538 651.26C553.19 631.506 531.085 607.049 489.225 612.222C434.196 619.277 412.561 740.623 515.093 790.479C532.966 881.253 484.051 872.787 484.051 872.787C467.59 806 329.312 663.959 328.841 570.363C328.841 444.313 392.336 408.568 392.336 408.568C394.218 320.616 485.933 223.727 640.202 227.019C794.471 229.841 889.008 225.608 919.109 189.393C949.211 152.236 1090.78 256.65 1057.39 377.526Z",
    fill: "#FFEA81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.15 522.859C1056.45 553.431 1043.28 576.947 1024.93 594.35C1031.99 543.083 1028.23 518.626 1022.11 489.936C1008.94 431.144 980.724 380.348 933.69 342.721C957.207 340.84 981.194 346.014 1002.83 359.653C1002.83 359.183 1080.43 390.695 1061.15 522.859Z",
    fill: "#FFEA81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.901 690.441C517.901 690.441 480.274 684.797 483.096 737.475C484.507 764.284 484.507 778.864 484.037 786.389C483.566 791.563 486.859 796.266 491.562 798.148C497.206 800.499 503.32 798.148 506.142 792.504C510.375 784.978 515.079 774.631 515.079 766.165C515.079 752.055 530.129 739.356 530.129 739.356C530.129 739.356 516.49 727.598 517.901 690.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.721 1597.24C627.959 1593.01 480.274 1340.44 502.38 1245.43C517.43 1180.06 497.676 1104.8 480.274 1038.49C473.219 1011.21 466.634 985.811 462.872 963.235C456.287 924.197 460.99 887.041 476.982 852.706C494.384 814.139 491.562 780.745 491.562 780.275L500.969 779.334C500.969 780.745 503.791 816.02 485.448 856.469C470.397 888.922 466.164 924.667 472.278 961.824C476.041 983.929 482.626 1009.33 489.681 1036.61C507.553 1103.86 527.307 1180.53 511.786 1248.26C491.092 1338.56 638.306 1591.13 639.247 1592.07L631.721 1597.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.508 764.754C484.978 775.101 484.508 782.156 484.508 786.389C484.037 791.563 487.33 796.266 492.033 798.147C497.677 800.499 503.791 798.147 506.613 792.503C510.846 784.978 515.55 774.631 515.55 766.165C515.55 765.694 515.55 764.754 515.55 764.283C505.673 768.046 494.385 770.868 484.508 764.754Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.09 1077.53C923.798 1099.16 923.328 1133.5 922.387 1173.47C920.976 1250.61 875.354 1551.15 853.248 1598.65L844.782 1594.89C865.947 1548.8 911.569 1249.67 912.98 1173.47C913.921 1133.5 914.391 1098.69 917.684 1076.11C924.739 1028.61 919.565 992.865 916.743 977.815C918.154 976.404 919.565 975.463 920.976 974.052C922.387 973.111 923.328 971.7 924.739 970.76C927.561 982.988 935.556 1022.03 927.09 1077.53Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy1);
export default __webpack_public_path__ + "static/media/Boy_1.9cf7de3464b629606b9ed8df565e5232.svg";
export { ForwardRef as ReactComponent };